module.exports = "/assets/Inter-SemiBold.d2e3b0e2.woff";